import React, { Component } from "react";
import TabbedInstructionHeader from "./TabbedInstructionHeader";
import * as pageData from "./PageData";
const $ = window.$;

const hashedLine = "###############";
const longLine = "---------------";
const shortLine = "----------";

var completionText;

/* eslint-disable no-unused-vars */
const tryButton1 = 1;
const example1 = 2;
const tryButton2 = 3;
const example2 = 4;
const tryButton3 = 5;
const example3 = 6;
const tryButton4 = 7;
const example4 = 8;
const completed = 9;
/* eslint-enable */

export default class InspectionTimeInstruction extends Component {
    constructor(props) {
        super(props);
        completionText = pageData.getInspectionTimePracticeCompletedText();
        this.circleClick = this.circleClick.bind(this);
        this.buttonClick = this.buttonClick.bind(this);
        this.state = {
            innerStep: tryButton1
        };
    }

    circleClick(tabId) {
        if (!this.props.waitingForSpeech) {
            this.props.setCurrentTab(tabId);
        }
    }

    buttonClick() {
        const innerStep = this.state.innerStep + 1;

        this.setState({ innerStep: innerStep });

        switch (innerStep) {
        case example2:
            this.applyHashtags(500);
            break;
        case example3:
            this.applyHashtags(400);
            break;
        case example4:
            this.applyHashtags(300);
            break;
        case completed:
            this.props.clearDisableNext();
                this.props.playSpeechForInstructionEnd(completionText);
            break;
        default:
        }
    }

    applyHashtags(delayInMs) {
        setTimeout(function() {
            $(".line-1").text(hashedLine);
            $(".line-3").text(hashedLine);
        }, delayInMs);
    }

    render() {
        const p = this.props;

        return (
<div className="test-page-content-inner test-page-instruction test-page-inspection-time-instruction" >
    <TabbedInstructionHeader currentTabId={p.currentTabId} elems={p.content.elems[0].elems} circleClick={this.circleClick} />
    <div className="practice-content">
        {renderPractice(p, this.state, this.buttonClick)}
    </div>
</div>
        );
    }
}

function renderPractice(props, state, buttonClick) {
    if (state.innerStep >= completed) {
        var inner = completionText.map(function (str, index) {
            return (<p key={index + 1}>{str}</p>);
        });

        return (
            <div className="practice-completed">
                <i key="0" className="far fa-check"></i>
                {inner}
            </div>
        );
    }

    return (
<div className="practice-content-inner">
    <div className="practice-col-1">
        {renderPracticeLines(state)}
    </div>
    <div className="practice-col-2">
        {renderPracticeButtons(props, state, buttonClick)}
    </div>
</div>
    );
}

function renderPracticeLines(state) {
    if ((state.innerStep > 1 && state.innerStep % 2 === 1) || (state.innerStep >= 9)) {
        return null;
    }

    const topLineLonger = Math.floor((state.innerStep + 1) / 2) % 2 === 1;

    return (
<div className="lines">
    <div className="line-1">{topLineLonger ? longLine : shortLine}</div>
    <div className="line-2">+</div>
    <div className="line-3">{topLineLonger ? shortLine : longLine}</div>
</div>
    );
}

function renderPracticeButtons(props, state, buttonClick) {
    if (state.innerStep >= completed) {
        return null;
    }

    if (state.innerStep % 2 === 1) {
        return renderTryButton(props, state, buttonClick);
    }

    const disabled = props.waitingForSpeech ? "disabled" : "";
    return (
        <React.Fragment>
            <button key="1" className="btn btn-choose-line button-1" onClick={() => buttonClick()} disabled={disabled}>TOP LINE LONGER</button>
            <button key="2" className="btn btn-choose-line button-2" onClick={() => buttonClick()} disabled={disabled}>BOTTOM LINE LONGER</button>
        </React.Fragment>
    );
}

function renderTryButton(props, state, buttonClick) {
    if (state.innerStep % 2 === 0) {
        return null;
    }

    const disabled = props.waitingForSpeech ? "disabled" : "";
    const label = state.innerStep === 1 ? "TRY" : "TRY AGAIN";
    return (
        <button key="3" className="btn btn-secondary btn-try" onClick={() => buttonClick()} disabled={disabled}>{label}</button>
    );
}